
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiEditGoogle as ObiEditGoogleElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-edit-google.js';
 
 
 

 
 export const ObiEditGoogle = createComponent({
   react: React,
   tagName: 'obi-edit-google',
   elementClass: ObiEditGoogleElement,
   events: {
     
   }
  });
 
 